module.exports = __webpack_public_path__ + "img/cef2cf7941340a4e36353c169ce434a0.png";